import { StepComponent } from '../modules/credit-application/components/stepcomponent.class';
import {
  Action,
  IAnalyticsErrorResponse,
  IConfirmationClickEvent,
  IPreQualEvent
} from '../interfaces/analytics.interface';

export enum AnalyticsActionTypes {
  ComponentLoaded = 'COMPONENT LOADED',
  SubmitCurrentStep = 'SUBMIT CURRENT STEP',
  SubmitInitiated = 'SUBMIT INITIATED',
  FormStarted = 'FORM STARTED',
  LeadDataSubmit = 'LEAD DATA SUBMIT',
  FormFailure = 'FORM FAILURE',
  FormSuccess = 'FORM SUCCESS',
  NextCTAClick = 'NEXT CTA CLICKED',
  EditCTAClick = 'EDIT CTA CLICKED',
  SubmitApplication = 'SUBMIT APPLICATION',
  UnlockCreditApp = 'UNLOCK CREDIT APP',
  CreateNewCreditApp = 'CREATE NEW CREDIT APP',
  ServerError = 'SERVER ERROR',
  PreQualComponentLoaded = 'PREQUALIFICATION APPLICATION LOADED',
  PreQualFormEvents = 'PREQUALIFICAION FORM EVENT',
  PreQualConfirmationClickEvents = 'PREQUALIFICATION APPLICATION CONFIRMATION CLICKED EVENTS',
  PreQualConfirmationComponentLoaded = 'PREQUALIFICATION APPLICATION CONFIRMATION LOADED',
  ContactStoreComponentLoaded = 'CONTACT STORE COMPONENT LOADED',
}

export class ComponentLoaded implements Action {
  readonly type = AnalyticsActionTypes.ComponentLoaded;
  constructor(public payload: StepComponent) { }
}

export class PreQualFormEvents implements Action {
  readonly type = AnalyticsActionTypes.PreQualFormEvents;
  constructor(public payload: IPreQualEvent) { }
}

export class PreQualComponentLoaded implements Action {
  readonly type = AnalyticsActionTypes.PreQualComponentLoaded;
  constructor(public payload: IPreQualEvent) { }
}

export class PreQualConfirmationClickEvents implements Action {
  readonly type = AnalyticsActionTypes.PreQualConfirmationClickEvents;
  constructor(public payload: IConfirmationClickEvent) { }
}

export class ContactStoreComponentLoaded  implements Action {
  readonly type = AnalyticsActionTypes.ContactStoreComponentLoaded;
  constructor(public payload: any) { }
}
export class PreQualConfirmationComponentLoaded implements Action {
  readonly type = AnalyticsActionTypes.PreQualConfirmationComponentLoaded;
  constructor(public payload: IPreQualEvent) { }
}

export class SubmitApplication implements Action {
  readonly type = AnalyticsActionTypes.SubmitApplication;
  constructor(public payload: StepComponent) { }
}

export class SubmitInitiated implements Action {
  readonly type = AnalyticsActionTypes.SubmitInitiated;
  constructor(public payload: StepComponent) { }
}

export class FormStarted implements Action {
  readonly type = AnalyticsActionTypes.FormStarted;
  constructor(public payload: StepComponent) { }
}

export class LeadDataSubmit implements Action {
  readonly type = AnalyticsActionTypes.LeadDataSubmit;
  constructor(public payload: StepComponent) { }
}

export class FormFailure implements Action {
  readonly type = AnalyticsActionTypes.FormFailure;
  constructor(public payload: StepComponent) { }
}

export class FormSuccess implements Action {
  readonly type = AnalyticsActionTypes.FormSuccess;
  constructor(public payload: StepComponent) { }
}

export class NextCTAClick implements Action {
  readonly type = AnalyticsActionTypes.NextCTAClick;
  constructor(public payload: StepComponent) { }
}

export class EditCTAClick implements Action {
  readonly type = AnalyticsActionTypes.EditCTAClick;
  constructor(public payload: StepComponent) { }
}

export class UnlockCreditApp implements Action {
  readonly type = AnalyticsActionTypes.UnlockCreditApp;
  constructor(public payload: StepComponent) { }
}

export class CreateNewCreditApp implements Action {
  readonly type = AnalyticsActionTypes.CreateNewCreditApp;
  constructor(public payload: StepComponent) { }
}

export class ServerError implements Action {
  readonly type = AnalyticsActionTypes.ServerError;
  public data: IAnalyticsErrorResponse;
  constructor(public payload: StepComponent, data?: IAnalyticsErrorResponse) {
    this.data = data;
  }
}

export type Actions = ComponentLoaded
  | SubmitApplication
  | SubmitInitiated
  | FormStarted
  | LeadDataSubmit
  | FormFailure
  | FormSuccess
  | NextCTAClick
  | EditCTAClick
  | UnlockCreditApp
  | CreateNewCreditApp
  | ServerError
  | PreQualComponentLoaded
  | PreQualConfirmationComponentLoaded
  | PreQualConfirmationClickEvents
  | PreQualFormEvents
  | ContactStoreComponentLoaded;
